/**
 * Formats seconds into a readable time string (MM:SS or HH:MM:SS)
 */
export const formatTime = (time: number): string => {
  if (isNaN(time) || !isFinite(time)) return '00:00';

  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = Math.floor(time % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

/**
 * Formats seconds into HH:MM:SS format for display and input
 */
export const formatSeconds = (seconds: number): string => {
  if (isNaN(seconds) || !isFinite(seconds)) return '00:00:00';

  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  return [hrs, mins, secs].map((v) => v.toString().padStart(2, '0')).join(':');
};

/**
 * Parses a time string in HH:MM:SS format to seconds
 */
export const parseTimeString = (input: string): number | null => {
  const regex = /^(\d{1,2}):([0-5]?\d):([0-5]?\d)$/;
  const match = input.match(regex);

  if (!match) return null;

  const [_, hours, minutes, seconds] = match;
  return parseInt(hours, 10) * 3600 + parseInt(minutes, 10) * 60 + parseInt(seconds, 10);
};

/**
 * Validates if a time is within a valid range
 */
export const validateTimeInRange = (time: number, min: number, max: number): boolean => {
  return time >= min && time <= max;
};
